import { useSnackbar } from 'notistack'
import React, { memo, useCallback } from 'react'
import { connect } from 'react-redux'

import { modificarCubicaje } from '../../../../../../../../models/movimiento/movimientoService'
import { closeDialog } from '../../../../../../../Forms/SharedComponents/containers/Dialog/actions/dialogActions'
import { actualizarEstadoSilos } from '../../../../../../actions'
import { OperacionModificarCubicajeView } from '../components/OperacionModificarCubicajeView'

export const OperacionModificarCubicaje = connect(null, { closeDialog, actualizarEstadoSilos })(
  memo(({ silo, closeDialog, actualizarEstadoSilos }) => {
    const { enqueueSnackbar } = useSnackbar()
    return (
      <OperacionModificarCubicajeView
        silo={silo}
        aceptar={async ({ metrosDeVacio, ph }) => {
          try {
            await modificarCubicaje(silo, metrosDeVacio, ph)
            closeDialog()
            enqueueSnackbar('Modificado de cubicaje correcto')
            actualizarEstadoSilos()
          } catch (error) {
            enqueueSnackbar('Modificado de cubicaje incorrencto', { variant: 'error' })
          }
        }}
        cancelar={useCallback(() => {
          closeDialog('MODIFICAR_CUBICAJE_SILO')
        }, [closeDialog])}
      />
    )
  })
)
